// extracted by mini-css-extract-plugin
module.exports = {"view":"MaintenanceView_view__1TG2w","title":"MaintenanceView_title__18pUO","message":"MaintenanceView_message__1p15M","error":"MaintenanceView_error__2bsld"};